const MOBILE = 'mobile';

/**
 * Calculates the offset X value based on the device type and site ID.
 *
 * @param {string} deviceType - The type of device (e.g., MOBILE).
 * @param {string} siteId - The site identifier (e.g., 'MLB').
 * @returns {number} The calculated offset X value.
 */
export function getOffSetX(deviceType, siteId) {
  if (deviceType === MOBILE) {
    return siteId === 'MLB' ? 27 : 1;
  }
  return siteId === 'MLB' ? -100 : -120;
}
